import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Section, Button } from "src/components/common"
import { social } from "src/data/config"
import { track } from "src/utils/track"
import { Frame, Lead, Actions, Direct, Notes } from "./styles"

export const Contact = () => {
  const { t } = useTranslation()
  const email = t("contact:email")
  const phoneHref = t("contact:phone_href")
  const mailto = `mailto:${email}?subject=${encodeURIComponent(
    t("contact:email_subject")
  )}`

  return (
    <Section id="contact" aria-labelledby="contact-title" $tone="dark">
      <Container>
        <Frame>
          <h2 id="contact-title">{t("contact:headline")}</h2>
          <Lead>{t("contact:lead")}</Lead>
          <Actions>
            <Button
              $variant="light"
              href={mailto}
              onClick={() =>
                track("mail_click", { location: "contact-button" })
              }
            >
              {t("contact:email_cta")}
            </Button>
            <Button
              $variant="ghost"
              href={`tel:${phoneHref}`}
              onClick={() =>
                track("phone_click", { location: "contact-button" })
              }
            >
              {t("contact:phone_cta")}
            </Button>
          </Actions>
          <Direct>
            <a
              href={mailto}
              onClick={() => track("mail_click", { location: "contact" })}
            >
              {email}
            </a>
            <a
              href={`tel:${phoneHref}`}
              onClick={() => track("phone_click", { location: "contact" })}
            >
              {t("contact:phone")}
            </a>
          </Direct>
          <Notes>
            <li>{t("contact:response")}</li>
            <li>{t("contact:location")}</li>
            <li>
              <a
                href={social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("contact:linkedin")}{" "}
                <span className="sr-only">({t("external_link")})</span>
              </a>
            </li>
          </Notes>
        </Frame>
      </Container>
    </Section>
  )
}
